var map = {
	"./ka/generated_payments_dark_sprites.svg": 6520,
	"./ka/generated_payments_light_sprites.svg": 61414,
	"./ka/generated_sprites.svg": 83561,
	"./pg/generated_payments_dark_sprites.svg": 95911,
	"./pg/generated_payments_light_sprites.svg": 85511,
	"./pg/generated_sprites.svg": 4142,
	"./po/generated_payments_dark_sprites.svg": 52271,
	"./po/generated_payments_light_sprites.svg": 91711,
	"./ps/generated_payments_dark_sprites.svg": 17011,
	"./ps/generated_payments_light_sprites.svg": 39915,
	"./ps/generated_sprites.svg": 67586
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74041;